import InventoryLocationPage from '@/components/Inventory/InventoryLocationPage';
import inventoryLocations from '@/resources/inventoryLocations';
import { AppResponse } from '@/types';

export default function inventoryLocationsForPage(appConfig: AppResponse) {
  return inventoryLocations(appConfig).editUsing(InventoryLocationPage);
}
